import { render, staticRenderFns } from "./AddContentModal.vue?vue&type=template&id=3b2a0795&scoped=true&"
import script from "./AddContentModal.vue?vue&type=script&lang=js&"
export * from "./AddContentModal.vue?vue&type=script&lang=js&"
import style0 from "./AddContentModal.vue?vue&type=style&index=0&id=3b2a0795&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b2a0795",
  null
  
)

export default component.exports